export default __webpack_public_path__ + "static/media/backArrowLb.093684d1.svg";